import fetcher from 'request/search/courses'
import Hero from './hero'

export default function Academy() {
  const t = useI18n()
  const { state, mutate } = useStatic({
    records: [],
    fetching: true,
    key: 'slug',
    keyword: '',
    loadMoreClick: null,
    teacher: null
  })

  useBodyScroll({
    state,
    mutate,
    reset: true,
    startLimit: 6,
    limit: 12,
    showLoadMore: true,
    fetcher,
    fetcherParams: () => ({ keyword: state.keyword })
  }, [state.keyword])

  const renderBody = () => (
    <div className='container mt-2 grid grid-cols-1 sm:gap-4 sm:grid-cols-2 md:grid-cols-3'>
      { state.records.map(course => (
        <Row
          key={ course.slug }
          course={ course }
          t={ t }
        />
      )) }
    </div>
  )

  const renderLoading = () => {
    if (state.fetching) return <div className='py-5'><C.Loading /></div>
    if (!state.records.length) return (
      <div className='py-5 text-center text-gray-600 mb-16 flex flex-col'>
        <div>{ t('page:academy.noResult') }</div>
        <div className='py-3'>
          <C.Link href={ h.path.academy({}) } className='text-sm text-gray-500'>{ t('page:academy.backToList') }</C.Link>
        </div>
      </div>
    )

    if (state.scrollConfig.isFinish) return
    return (
      <div className='pb-5 flex justify-center'>
        <C.Button className='w-[90%] md:w-[16rem]' onClick={ state.loadMoreClick }>載入更多</C.Button>
      </div>
    )
  }

  return (
    <div className='pb-10'>
      <Hero />
      { renderBody() }
      { renderLoading() }
    </div>
  )
}

const Row = ({ course }) => {
  const { teacher } = course

  const renderImage = ({ src, className }) => {
    if (!src) return <div className={ cn('bg-gray-100', className) }></div>
    return <C.Image
      src={ src }
      className={ className }
    />
  }

  const renderOtherTag = () => course.tags.slice(0, 2).map((text, idx) => (
    <div key={ idx } className='py-1 px-2 mr-[0.35rem] rounded-[4px] bg-gray-100 text-gray-500'>
      <span className='line-clamp-1'>{ text }</span>
    </div>
  ))

  const renderCourseTime = () => {
    const { startTime, endTime } = course
    if (startTime.ymd === endTime.ymd) return startTime.ymdw()
    return `${startTime.ymd()} ~ ${endTime.ymd()}`
  }

  return (
    <C.Link href={ h.path.course({ slug: course.slug }) } noUnderline>
      <div className='mb-6'>

        <div className='flex rounded-[10px] overflow-hidden relative'>
          <div className='flex-[2_0_0%] m-0'>
            { renderImage({
              src: course.coverUrls[0]?.large.url,
              className: 'pt-[100%]'
            }) }
          </div>
          <div className='flex-1 flex flex-col'>
            { renderImage({
              src: course.coverUrls[1]?.small.url,
              className: 'pt-[100%]'
            }) }
            { renderImage({
              src: course.coverUrls[2]?.small.url,
              className: 'pt-[100%]'
            }) }
            <div className='absolute inset-0 bg-black/50 text-white flex flex-col items-center justify-center opacity-100 hover:backdrop-blur-sm hover:bg-black/70 transition-all'>
              <div className='line-clamp-1 text-[1.4rem] px-3'>{ renderCourseTime() }</div>
              <div className='line-clamp-1 text-[1.3rem] px-3'>{ course.title }</div>
            </div>
          </div>
        </div>

        <div>
          <div className='pt-2 flex text-xs'>

            <div className='shrink-0 py-1 px-2 mr-[0.35rem] rounded-[4px] bg-gray-800 text-white'>
              { teacher.name }老師
            </div>
            { renderOtherTag() }
          </div>
        </div>
        <div className='pt-[0.2rem] text-[0.9rem] text-gray-500 line-clamp-1'>{ course.address }</div>
      </div>
    </C.Link>
  )
}
